export var sizes = ['s', 'm', 'l', 'xl'];
export var weights = ['semibold', 'inherit'];
export var displays = ['block', 'flex', 'inline', 'inline-block'];
export var displaysMap = {
  block: 'block',
  flex: 'flex',
  inline: 'inline',
  'inline-block': 'inline_block'
};
export var alignments = ['center', 'right', 'left'];
export var alignmentsMap = {
  center: 'center',
  right: 'right',
  left: 'left'
};